import React from 'react';
import Weather from './components/Weather';
import 'antd/dist/antd.css';
import './App.css';

function App() {
  return (
    <div className="App">
      <Weather />
    </div>
  );
}

export default App;
